export default __webpack_public_path__ + "static/media/menubar_arrow.4e11cb1f.svg";